module.exports = __webpack_public_path__ + "static/media/19-3.8681b558.mp3";